export const deserializeQueryString = (queryString = window.location.search.substr(1)) => {
	const query = {};

	(queryString || "")
		.replace("?", "&")
		.split("&")
		.forEach((item) => {
			let a = item.split("=");
			query[decodeURIComponent(a[0])] = decodeURIComponent(a[1] || "");
		});

	return query;
};

export const serializeQuery = (query = {}) => {
	var queryString = [];

	for (let key in query) {
		if (key) {
			queryString.push(encodeURIComponent(key) + "=" + encodeURIComponent(query[key]));
		}
	}

	return queryString.join("&");
};

export const appendQueryParams = (params = {}, url = window.location.href) => {
	const loc = new URL(url.charAt(0) === "/" ? window.location.origin + url : url);
	const query = Object.assign(deserializeQueryString(loc.search), params);

	for (let x in query) {
		if (query[x] === null) {
			delete query[x];
		}
	}

	return new URL(loc.origin + loc.pathname + "?" + serializeQuery(query));
};

export function makeContinueUrl(to, continueTo) {
	const location = window.location;
	const query = deserializeQueryString();
	const $continue = continueTo ? continueTo + location.search : query.continue || location.pathname + location.search;

	return to;
}
